import { useMutation } from "react-query";
import { uploadValidMassAgreementData } from "../../../../actions/CarrierAgreementMgmt/Agreements";
const useSaveMassUpload = () => {
  return useMutation(uploadValidMassAgreementData);
};

export default useSaveMassUpload;
